import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService, UserService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import moment from "moment";
import { WorkdayReportService } from "../../workday-report.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-collaborators-by-providers-report",
  templateUrl: "./collaborators-by-providers-report.component.html",
  styleUrls: ["./collaborators-by-providers-report.component.scss"],
})
export class CollaboratorsByProvidersReportComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("tableHeader") tableHeader: ElementRef;
  public contentHeader: IContentHeader;
  public currentMonthAndYear: any = moment().format("MMMM YYYY"); //Il mese e anno corrente del report (isStaffMode false)
  public lastDayCurrentMonth: any = moment().endOf("month").format("DD");
  public myReport: any = {}; // Sarà contenuto il report generato e anche quello caricato(sia dall'utente che da parte della visualizzazione dello staff
  public available_working_days: Array<number> = [];
  public totalWorkedHours: number = 0;
  public daysOfTheMonth: any = [];
  public today: any = moment().format("DD-MM-YYYY");
  public idReport: number = null; //Variabile valorizzata solo nel caso della modalità isStaffMode true
  public reportMonth: number = moment().month() + 1;
  public reportYear: number = moment().year();
  public statusReport: number = -1;
  public myProfile: any;
  public rowsWithErrorMissingHours: string[] = [];

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _workdayReport: WorkdayReportService,
    private activatedRoute: ActivatedRoute,
    public _routerService: Router,
    public _userService: UserService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this._utilService.disableAutoHideLoading();
    // gestione dei parametri url
    this.activatedRoute.params.subscribe((params) => {
      if (params.hasOwnProperty("id")) {
        //Se è presente un id entriamo in staffMode
        this.idReport = Number(params.id);
      }
    });
    // gestione dei query params
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.hasOwnProperty("month")) {
        this.reportMonth = Number(params.month);
      }

      if (params.hasOwnProperty("year")) {
        this.reportYear = Number(params.year);
      }
    });

    this.contentHeader = {
      headerTitle: "WORKDAY_REPORT_OF",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.WORKDAY_USERS_REPORTS",
            isLink: true,
            link: "/dashboard/workday-report/collaborators-by-providers-reports",
          },
          {
            name: "",
            isLink: false,
          },
        ],
      },
    };
    // Parametro gestito da configurazione per i giorni lavorativi
    this.available_working_days = this._utilService.themeConfiguration.working_days;
  }

  async ngOnInit() {
    this.myProfile = await this._userService.getMe();

    //////////////////////////////////////
    await this.selectReport();

    this._utilService.hideLoading();
    // gestione sticky table header
    if (this._utilService.isDesktop) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 270) {
          if (!this.tableHeader.nativeElement.classList.contains("sticky")) {
            this.tableHeader.nativeElement.classList.add("sticky");
          }
        } else {
          this.tableHeader.nativeElement.classList.remove("sticky");
        }
      });
    }
  }

  /*Funzione che sceglie se generare un report nel caso non vi siano report salvati a database per il periodo corrente, oppure se presente carica il report del database*/
  async selectReport() {
    /**
     * se c'è l'id nell'url vado a prendere direttamente quello
     */

    if (this.idReport) {
      const savedReport = await this._workdayReport.get(this.idReport);
      if (!savedReport) {
        await this._routerService.navigateByUrl("/dashboard/workday-report/my-archive");
        return false;
      }

      const headerTitle = await this._utilService.translate("WORKDAY_REPORT_OF");
      this.contentHeader.headerTitle = `${headerTitle} ${savedReport.complete_name}`;
      this.contentHeader.breadcrumb.links[3].name = `${headerTitle} ${savedReport.complete_name}`;

      this.statusReport = savedReport.status;
      this.reportMonth = savedReport.month;
      this.reportYear = savedReport.year;
      this.myReport = {};
      for (const item of savedReport.data) {
        const day: string = moment(item.date, "YYYY-MM-D").format("YYYY-MM-DD");
        delete item.date;
        this.myReport[day] = item;
      }

      this.totalWorkedHours = savedReport.worked_hours;
    } else {
      const savedReport: any = await this._workdayReport.getMineByDate(this.reportMonth, this.reportYear).then((result: any) => (!result || Object.keys(result).length < 1 ? null : result));

      this.idReport = savedReport.id;
      this.statusReport = savedReport.status;
      this.myReport = {};
      for (const item of savedReport.data) {
        const day: string = moment(item.date, "YYYY-MM-D").format("YYYY-MM-DD");
        delete item.date;
        this.myReport[day] = item;
      }
      /**
       * aggiorno le somme
       */
      this.calculateTotalHours();
    }

    this.currentMonthAndYear = moment(`${this.reportYear}-${this.reportMonth}`, "YYYY-MM").format("MMMM YYYY");

    // prendo i giorni del mese dall'oggetto
    this.daysOfTheMonth = Object.keys(this.myReport);
  }

  //Funzione per gestire i colori della visualizzazione della lista
  isWorkDay(day: string) {
    const dayN: number = Number(moment(day).format("d"));
    return this.available_working_days.includes(dayN);
  }

  getDayRowClasses(day: string) {
    let classes: string[] = [];

    if (this.isWorkDay(day)) {
      if (this._utilService.isHoliday(day)) {
        classes.push("holiday");
      } else {
        classes.push("work");
      }
    } else {
      classes.push("off");
    }

    if (this.rowsWithErrorMissingHours.includes(day)) {
      classes.push("bg-light-danger");
    }

    return classes.join(" ");
  }

  getDayRowTooltip(day: any) {
    if (this.rowsWithErrorMissingHours.includes(day)) {
      return "MISSING_SOME_HOURS_TO_ALLOCATE";
    }
    return null;
  }

  private calculateTotalHours() {
    // Calcolo ore totali di lavoro
    this.totalWorkedHours = 0;
    const daysList: any = Object.values(this.myReport);
    for (let day of daysList) {
      // totali
      this.totalWorkedHours += day.working_hours;
    }

    this._changeDetectorRef.detectChanges();
  }

  async update() {
    /**
     *  controllo se manca qualche ora e registro i giorni incompleti
     **/
    for (let day of Object.keys(this.myReport)) {
      if (this.myReport[day].working_hours == null) {
        this.rowsWithErrorMissingHours.push(day);
      }
    }
    // se c'è qualche errore esco dalla funzione
    if (this.rowsWithErrorMissingHours.length > 0) {
      const html: string = await this._utilService.translate("YOU_FORGOT_SOME_HOURS_IN_YOUR_REPORT");
      await this._utilService.showSWALError({ html });
      return false;
    }
    this._utilService.showLoading();

    return this._workdayReport
      .update(this.idReport, {
        report: this.myReport,
        status: 2,
        worked_hours: this.totalWorkedHours,
        extra_hours: 0,
      })
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_WORKDAY_REPORT" });
        this._routerService.navigateByUrl("/dashboard/workday-report/collaborators-by-providers-reports");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_SEND_WORKDAY_REPORT" });
      });
  }
}
